import React, { useState } from "react";
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import HasPermissionTo from "../../common/HasPermissionTo";
import { withTranslation } from "react-i18next";
import { THAILAND_THAI, THAILAND_ENGLISH } from "../../common/Constants";
import LanguageUtil from "../../utils/LanguageUtil";
import HelpAndSupportDialog from "./HelpAndSupportDialog";
import { publish } from "../../common/PubSub";

const Footer = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const toggleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  const updateLanguage = (language) => {
    LanguageUtil.updateLanguage(props, language);
    publish("language", language);
  };

  return (
    <div className={styles.footerBox} data-testid="appFooter">
      <div className={styles.footerTitleBox}>{props.t("Footer.title")}</div>
      <div className={styles.helpContainer}>
        <HasPermissionTo
          perform={["languagePreference:write"]}
          permissions={props.permissions.rolePermissions}
          render={() => (
            <>
              <button
                data-testid="english"
                onClick={() => updateLanguage(THAILAND_ENGLISH)}
              >
                ENGLISH
              </button>
              <button
                data-testid="thai"
                onClick={() => updateLanguage(THAILAND_THAI)}
              >
                ไทย
              </button>
            </>
          )}
        />
        <HasPermissionTo
          perform={["helpAndSupportLink"]}
          permissions={props.permissions.rolePermissions}
          render={() => (
            <Link
              to={{
                pathname: "/help",
              }}
            >
              {props.t("Footer.help")}
            </Link>
          )}
        />
        <HasPermissionTo
          perform={["helpAndSupportModal"]}
          permissions={props.permissions.rolePermissions}
          render={() => {
            return (
              <div>
                <button onClick={toggleModal}>{props.t("Footer.help")}</button>
                <HelpAndSupportDialog
                  {...props}
                  open={openModal}
                  closeModal={toggleModal}
                />
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default withTranslation("emp")(Footer);
